'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import Avatar from "Avatar";
// import MiniModal from "ui/MiniModal";
// import RoomInfo from "./RoomInfo";
// import MessageEditor from "ui/Chat/Message/Editor";
// import Message from "./Message";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Grid = require('material-ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _InfoOutline = require('material-ui-icons/InfoOutline');

var _InfoOutline2 = _interopRequireDefault(_InfoOutline);

var _Clear = require('material-ui-icons/Clear');

var _Clear2 = _interopRequireDefault(_Clear);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _CallButton = require('./CallButton');

var _CallButton2 = _interopRequireDefault(_CallButton);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  root: {
    // border: "1px solid blue",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    backgroundColor: "#f4f5f6",
    borderRadius: 5 // maxWidth: 1200,
    // margin: "0 auto",

  },
  header: {
    padding: "5px 16px",
    backgroundColor: "#fff",
    "& .videoButton": {
      height: "2rem",
      borderRadius: "1rem",
      justifyContent: "space-between",
      padding: "0 12px",
      marginRight: 10
    },
    "& .avatar": {
      border: "2px solid #fff",
      marginLeft: -8,
      cursor: "pointer"
    }
  },
  content: {
    // flex: "1 1",
    // border: "1px solid green",
    // padding: 15,
    height: "100%"
  },
  showMember: {
    position: "absolute",
    bottom: 0 // "& .border": {
    //   boxShadow: "0px 0px 2px 2px #0000001f",
    // },
    // "& .border-radius": {
    //   borderRadius: "2px",
    // },
    // "& .bg": {
    //   backgroundColor: "white",
    // },
    // "& .wrapper": {
    //   position: "absolute",
    //   zIndex: 10,
    //   top: 8,
    //   left: -10,
    //   "& .corner": {
    //     transform: "rotate(45deg)",
    //     width: 10,
    //     height: 10,
    //     top: -5,
    //     left: 16,
    //     position: "absolute",
    //     zIndex: 20,
    //   },
    //   "& .content": {
    //     padding: 15,
    //     position: "relative",
    //     zIndex: 30,
    //   },
    // },

  }
}; // class RoomChatView extends RoomView {

var RoomChatView = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(RoomChatView, _PrismaCmsComponent);

  function RoomChatView(props) {
    _classCallCheck(this, RoomChatView);

    var _this = _possibleConstructorReturn(this, _PrismaCmsComponent.call(this, props));

    _this.state = _extends({}, _this.state, {
      showRoominfo: false
    });
    return _this;
  }

  RoomChatView.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        classes = _props.classes,
        room = _props.room,
        callButtons = _props.callButtons;
    var _context = this.context,
        currentUser = _context.user,
        Avatar = _context.Avatar;

    if (!room || !currentUser) {
      return null;
    }

    var showRoominfo = this.state.showRoominfo;
    var roomId = room.id;
    var membersIcons = [];
    var currentUserId = currentUser.id; // let otherMembers = members.filter(n => n.id !== currentUserId);
    // let otherMembers = members;

    var zIndex = 0; // membersIcons = otherMembers.map(n => {
    //   const {
    //     id,
    //     fullname,
    //     city,
    //   } = n;
    //   zIndex++;
    //   return <div
    //     key={id}
    //     style={{
    //       zIndex,
    //       position: "relative",
    //     }}
    //   >
    //     <Avatar
    //       className="avatar"
    //       user={n}
    //       size="default"
    //       onClick={event => {
    //         this.setState({
    //           showMember: showMember === id ? undefined : id,
    //         })
    //       }}
    //     />
    //     {showMember && showMember === id
    //       ?
    //       <div
    //         className={classes.showMember}
    //       >
    //         {/* <MiniModal> */}
    //           <Grid
    //             container
    //             spacing={16}
    //             alignItems="center"
    //             style={{
    //               flexWrap: "nowrap",
    //             }}
    //           >
    //             <Grid
    //               item
    //             >
    //               <Avatar
    //                 user={n}
    //                 size="middle"
    //                 style={{
    //                   border: "1px solid #ddd",
    //                 }}
    //               />
    //             </Grid>
    //             <Grid
    //               item
    //               xs
    //               style={{
    //                 whiteSpace: "nowrap",
    //               }}
    //             >
    //               <Typography
    //                 style={{
    //                   fontWeight: 600,
    //                   color: "#666",
    //                   fontSize: "0.9rem",
    //                 }}
    //               >
    //                 {fullname}
    //               </Typography>
    //               {city
    //                 ?
    //                 <Typography
    //                   style={{
    //                     color: "#888",
    //                     fontSize: "0.7rem",
    //                   }}
    //                 >
    //                   {city}
    //                 </Typography>
    //                 : null
    //               }
    //             </Grid>
    //           </Grid>
    //         {/* </MiniModal> */}
    //       </div>
    //       : null
    //     }
    //   </div>
    // });

    var callButton = void 0; // if (Call) {
    //   callButton = <button
    //     className="videoButton button bg-green"
    //   >
    //     <VideoCamIcon
    //     // style={{
    //     //   fill: "transparent",
    //     //   stroke: "#fff",
    //     // }}
    //     /> Show video chat
    //   </button>;
    // }
    // else {
    //   callButton = <button
    //     className="videoButton button bg-blue"
    //   >
    //     <VideoCamIcon
    //     // style={{
    //     //   fill: "transparent",
    //     //   stroke: "#fff",
    //     // }}
    //     /> Request a video call
    //   </button>;
    // }

    callButton = _react2.default.createElement(_CallButton2.default, {
      room: room,
      currentUser: currentUser // showVideoChatHandler={showVideoChatHandler}

    });

    var header = _react2.default.createElement('div', {
      className: classes.header
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      spacing: 8,
      alignItems: 'center'
    }, _react2.default.createElement(_Grid2.default, {
      item: true // xs={12}
      // md
      ,
      style: {
        flexGrow: 1
      }
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      alignItems: 'center',
      style: {
        flexWrap: "nowrap"
      }
    }, _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: true
    }), _react2.default.createElement(_Grid2.default, {
      item: true
    }, callButton), _react2.default.createElement(_Grid2.default, {
      item: true
    }, _react2.default.createElement('div', {
      style: {
        // position: "relative",
        marginRight: 10
      }
    }, _react2.default.createElement(_IconButton2.default, {
      style: {
        height: "auto",
        width: "auto"
      },
      onClick: function onClick(event) {
        _this2.setState({
          showRoominfo: !showRoominfo
        });
      }
    }, _react2.default.createElement(_InfoOutline2.default, {
      className: showRoominfo ? "text-blue" : "",
      style: {
        fontSize: "2.3rem"
      }
    })), _react2.default.createElement(_IconButton2.default, null, _react2.default.createElement(_Clear2.default, null)))))))); // return super.render(


    return _react2.default.createElement('div', {
      className: classes.root
    }, _react2.default.createElement('div', {
      className: classes.content
    }, _react2.default.createElement('div', {
      style: {
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column" // border: "1px solid blue",

      }
    }, header, _react2.default.createElement('div', {
      style: {
        backgroundColor: "#e6edf0"
      }
    }, _react2.default.createElement('div', {
      style: {
        margin: "0 auto",
        maxWidth: 1000,
        padding: "0 15px"
      }
    }, _react2.default.createElement('form', {
      onSubmit: function onSubmit(event) {
        event.preventDefault();

        _this2.sendMessage();
      }
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      spacing: 16,
      alignItems: 'center'
    }, callButtons && callButtons.length ? _react2.default.createElement(_Grid2.default, {
      item: true
    }, callButtons) : null)))))));
  };

  return RoomChatView;
}(_component2.default), _class.propTypes = {
  // ...RoomView.propTypes,
  // showVideoChatHandler: PropTypes.func.isRequired,
  callButtons: _propTypes2.default.array.isRequired
}, _temp);
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(RoomChatView, props);
});
module.exports = exports['default'];